import { EdenMark } from "@/components/Logo";

export const ChannelMark = ({ channel, small = false }) => {
  if (channel.eden) {
    return (
      <span className={`channel-logo channel-logo-eden ${small ? "small" : ""}`} style={{ "--brand": "#1F3B2D" }}>
        <EdenMark height={small ? 20 : 26} arch="#1F3B2D" />
        <b>Eden Direct</b>
      </span>
    );
  }
  if (channel.file) {
    const height = Math.round((channel.h || 26) * (small ? 0.72 : 1));
    return (
      <span className={`channel-logo has-file ${small ? "small" : ""}`}>
        <img src={channel.file} alt={channel.label} className="channel-img" style={{ height }} loading="lazy" />
      </span>
    );
  }
  return (
    <span className={`channel-logo ${channel.cls} ${small ? "small" : ""}`} style={{ "--brand": channel.color }}>
      {channel.label}
    </span>
  );
};
